import { render } from "./GtrFly.vue?vue&type=template&id=e82217cc&scoped=true&ts=true"
import script from "./GtrFly.vue?vue&type=script&lang=ts"
export * from "./GtrFly.vue?vue&type=script&lang=ts"

import "./GtrFly.vue?vue&type=style&index=0&id=e82217cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82217cc"]])

export default __exports__